var _style, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _polygon2, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _path14, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850 550",
    style: {
      enableBackground: "new 0 0 850 550"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#E6E6E6;}\n\t.st2{fill:#3F3D56;}\n\t.st3{fill:#2F2E41;}\n\t.st4{fill:#FFB6B6;}\n\t.st5{fill:url(#SVGID_1_);}\n\t.st6{fill:#CACACA;}\n\t.st7{fill:url(#SVGID_00000127002505123586484700000013751771246602285187_);}\n\t.st8{fill:url(#SVGID_00000145759456835291282190000005537501068473468814_);}\n\t.st9{fill:url(#SVGID_00000072242657022722375810000015335245955801056438_);}\n\t.st10{fill:url(#SVGID_00000176738101880349722990000006208546887867568769_);}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:url(#SVGID_00000129902662285138620800000003333956529081703084_);}\n\t.st13{fill:url(#SVGID_00000008149786744043450790000009152668419749971078_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M415.3,515.9l-0.6-13.8c-0.1,0-0.2-0.1-0.2-0.1c-6.6-3.5-14.1,2.8-12,9.9c2,6.7,3.3,13.9,6.9,19.8 c4.3,6.9,11.5,11.5,19.6,12.4l8.3,5.1c2.4-13-1.2-26.2-9.5-36.4c-2.4-2.8-5-5.3-8-7.4C417.9,510.8,415.3,515.9,415.3,515.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.5,375.9c-16.1-16.6-39.4-26.1-64-26.1h-0.9c-16.2,0-32-4.3-46-12.4l-1.5-0.9l1.2-1.2 c6.4-6.6,11.6-14,15.7-22.2c-5.8,5.4-13.8,8-21.7,7c-8.4-1-15.9-5.8-20.2-13c-8.6-14-18.8-33.7-18.8-48.7 c0-25.7,10.8-50.2,29.9-67.6c12-10.8,18.9-26.3,18.8-42.5v-1.2c0-10.5,1.3-21,3.8-31.3l0.2-1h1.1c6.8,0.2,13.7-0.3,20.4-1.7 c-6.3-0.8-12.5-2.4-18.4-4.9l-1.2-0.5l0.4-1.2c26.8-16.6,87.2-8,122.3-88.2c28.4-65.1,128.8,57.8,128.8,128.7 c0,7.2-7.1,16.8-1.8,21.6c58,51.7,18,85,5.3,118.4c-3,7.9,3.5,16.6,3.5,25.2c0,1.5,0,3-0.1,4.5l-0.1,2.4l-2-1.3 c-3.8-2.5-7.4-5.4-10.6-8.7c6.7,15.5,6.1,33.2-1.8,48.2c-6,11.5-11.9,19.7-17.5,24.4C428.8,413.4,374,410.8,340.5,375.9 L340.5,375.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M437.6,548.6c0.8,0,1.5-0.6,1.6-1.4c0.1-0.5,6.9-49.8,0.8-115.4c-5.7-60.5-23.9-147.7-78.4-219.3 c-0.5-0.7-1.6-0.9-2.3-0.3c-0.7,0.5-0.9,1.6-0.3,2.3l0,0c54.1,71,72.1,157.5,77.8,217.6c6.1,65.1-0.7,114.1-0.8,114.6 c-0.2,0.9,0.5,1.7,1.4,1.9C437.5,548.6,437.5,548.6,437.6,548.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M393.1,313.5c0.9,0,1.6-0.7,1.6-1.6c0-0.5-0.2-1-0.7-1.3c-0.2-0.2-20.2-14.5-50-25.4 c-27.5-10.1-69.5-19.2-112.7-5.5c-0.9,0.3-1.3,1.2-1.1,2c0.3,0.9,1.2,1.3,2,1.1l0,0c42.3-13.4,83.5-4.5,110.6,5.5 c29.4,10.8,49,24.9,49.2,25C392.4,313.4,392.7,313.5,393.1,313.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M468.3,126.3c0.1-0.9-0.6-1.7-1.5-1.7c-0.5,0-1,0.2-1.4,0.5c-0.2,0.2-15.9,19.1-29,48 c-12.1,26.8-24.2,68-13.6,112c0.2,0.9,1.1,1.4,2,1.2c0.9-0.2,1.4-1.1,1.2-2l0,0c-10.4-43.2,1.6-83.6,13.4-109.9 c12.9-28.6,28.3-47.1,28.5-47.2C468.2,126.9,468.3,126.6,468.3,126.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M466.1,210.9c1.4,11.2,9.1,20.4,20.4,20.4c11.3,0,20.4-9.1,20.4-20.4l0,0c0-11.3-9.2-19.4-20.4-20.4 C474.6,189.4,464.3,196.6,466.1,210.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "495.9,539.6 503.7,539.6 507.4,509.6 495.9,509.6  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M495.7,547.7h23.9v-0.3c0-5.1-4.2-9.3-9.3-9.3l0,0l-4.4-3.3l-8.2,3.3h-2.1L495.7,547.7z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "465.3,539.6 473.1,539.6 476.8,509.6 465.3,509.6  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M465.1,547.7H489v-0.3c0-5.1-4.2-9.3-9.3-9.3l0,0l-4.4-3.3l-8.2,3.3h-2.1L465.1,547.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M522.7,351.8l5.5,18.8l-6.4,79.7c0,0,3.3,5,0.9,5s-5.3,1.1-3.5,4.1c1.9,3-4.6,13.7-4.6,13.7l-9.2,56.8 l-11.7-0.2c0,0-6-3.3-2.6-6.7c3.4-3.4,5.7-3.4,2.6-6.5c-3.1-3.1-3.1-2.2-3.1-4.6s-3.1-32.2,4.3-43.6l-2.3-46.5l-5.3,45.7 l-10.9,60.9l-11.3-0.1c0,0-5.2-5-5.2-8.7c0-3.7,3.2-4,0.9-6.2c-2.4-2.2-2.4-36,4.7-54.8c0,0,4-10.5,0-14.1c-4-3.6,0-7.7,0-7.7 s6.4-2.3,0-8.9c-6.4-6.6,0-53.3,0-53.3s-6.9-18.8,0.1-26.3S522.7,351.8,522.7,351.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M424.8,384.3l9.8-23.7l7.7,4.3l-4.6,24.1c1.4,4.6-1.2,9.3-5.7,10.8c-4.6,1.4-9.3-1.2-10.8-5.7 C420.1,390.4,421.6,386.4,424.8,384.3L424.8,384.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M589.3,197l-14.9,20.9l-6.5-6l10-22.4c-0.3-4.7,3.2-8.8,8-9.2c4.7-0.3,8.8,3.2,9.2,8 C595.2,192.2,592.9,195.7,589.3,197z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.8703,
    y1: 411.4795,
    x2: 583.6862,
    y2: 411.4795,
    gradientTransform: "matrix(1 0 0 -1 0 701.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M524.2,353.8c9.7,15-38.9,34.1-57.6,26.4c-3.3-1.3-14.5-5.7-6.8-11.9c7.7-6.1-0.9-7-1.1-11 c-0.2-2.7,2-8.6-0.2-8.2c-2.2,0.3-4.7-3.5,0-5c4.7-1.6,0.1-3.1,0.1-4.6c0.5-16.5,13-42.6,13-42.6L448.8,355c0,0,0.2,10-2.7,7 c-2.9-3.1-2.7,6.9-2.7,6.9s-4.3,3-1.8,4.7c2.5,1.7-2.7,6.8-2.7,6.8l-12-0.9c0,0,0.2-8.9,2.3-10.9c2.1-2,1-5.1,1-5.1 s5.3-4.7,1.7-8.6c-4.6-4.9,12.2-88.3,18-87.5c1.6-8.2,7.8-14.6,15.8-16.9l13-3.6l2.4-9.1h18.3l3.2,6l13.9,6.3 c2.6-3.7,4.6-7.6,15.3-8.9c0,0,28.9-26.3,27.5-28.3c-1.4-2,3.1-6.8,3.1-6.8s3.8-1.3,1.6-1.9c-2.2-0.6,1.9-2.2,1.9-2.2s3.8-1,2-2.3 c-1.8-1.3,6-2.2,6-2.2l10,8.2l-2,3.5c0,0,1.3,4.7-0.4,3c-1.6-1.7-1.9,3.2-1.9,3.2s-0.8,5.4-5.7,7.1s-8.6,17.2-8.6,17.2 c-11.5,15-25.1,26.6-41.2,34.3C530.2,281.2,524.2,353.8,524.2,353.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 488.7,
    cy: 214.5,
    r: 18.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M470,216.4c0.5,3.9,3.9,9.4,3.1,9.4c-0.8,0-6.4-16.2-0.8-17.3c4.1-0.8,4.9-0.1,8.7-1.7l-0.5,0.5 c2.5,1.8,6,0.7,8.9-0.5c2.9-1.2,6.4-2.3,8.9-0.5c1.6,1.2,2.3,3.1,3.2,4.8c0.9,1.6,2.8,3.3,4.6,2.7c1.5-0.4,2.4-2.1,2.4-3.6 c0-1.5-2-3.1-1.3-4.4c2-4.2,0.2-7-4.2-8.9c-1.6-0.2-3.2-0.5-4.8-0.8c0.9-1.2,1.9-2.2,3-3.1c-0.5-1.3-1.3-2.4-2.4-3.1 c-1.3-0.8-2.9-0.7-4.3-0.6c-3.3,0.2-6.6,0.3-10,0.5c-2.4,0.2-4.9,0.3-7.1,1.4c-2.7,1.4-4.6,4.2-5.8,6.9 C468.5,204.6,469,209.6,470,216.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M394.8,549.8l178,0.2c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9l0,0l-178-0.2c-0.5,0-0.9,0.4-0.9,0.9 C393.8,549.3,394.2,549.8,394.8,549.8z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.144 -0.9896 0.9896 0.144 -184.7233 721.2402)",
    className: "st1",
    cx: 324.5,
    cy: 467.4,
    rx: 4.2,
    ry: 6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.144 -0.9896 0.9896 0.144 -148.0226 756.2452)",
    className: "st2",
    cx: 363.1,
    cy: 463.7,
    rx: 4.2,
    ry: 6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148659757242457016770000008165580174359496350_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.0287,
    y1: 265.0811,
    x2: 319.8279,
    y2: 265.0811,
    gradientTransform: "matrix(1 0 0 -1 0 701.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148659757242457016770000008165580174359496350_)"
    },
    d: "M308,435.3c0.3-2.3,3.2-3.7,6.4-3.2 c3.2,0.5,5.6,2.7,5.3,4.9c-0.3,2.3-3.2,3.7-6.4,3.2S307.7,437.6,308,435.3z"
  }), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 -126.0387 721.3909)",
    className: "st1",
    cx: 300.4,
    cy: 424.2,
    rx: 3.8,
    ry: 2.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 -107.8341 692.1449)",
    className: "st2",
    cx: 294.8,
    cy: 400.4,
    rx: 3.8,
    ry: 2.6
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 -105.8908 777.9188)",
    className: "st1",
    cx: 339,
    cy: 442.3,
    rx: 3.8,
    ry: 2.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061432910346244469600000011380122660690902659_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.6956,
    y1: 249.6978,
    x2: 322.9109,
    y2: 249.6978,
    gradientTransform: "matrix(1 0 0 -1 0 701.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061432910346244469600000011380122660690902659_)"
    },
    d: "M317.7,451.6c0-2,1.2-3.8,2.7-3.8 c1.4,0,2.6,1.7,2.6,3.8c0,2-1.2,3.8-2.7,3.8C318.9,455.3,317.7,453.7,317.7,451.6z"
  }), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 -125.1608 811.5704)",
    className: "st2",
    cx: 346.3,
    cy: 468.8,
    rx: 3.8,
    ry: 2.6
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.144 -0.9896 0.9896 0.144 188.8551 911.3592)",
    className: "st1",
    cx: 621.2,
    cy: 346.5,
    rx: 4.2,
    ry: 6
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.144 -0.9896 0.9896 0.144 225.556 946.3641)",
    className: "st2",
    cx: 659.8,
    cy: 342.8,
    rx: 4.2,
    ry: 6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171707764276266786660000014668132450838796952_",
    gradientUnits: "userSpaceOnUse",
    x1: 604.7069,
    y1: 385.9503,
    x2: 616.506,
    y2: 385.9503,
    gradientTransform: "matrix(1 0 0 -1 0 701.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171707764276266786660000014668132450838796952_)"
    },
    d: "M604.7,314.5c0.3-2.3,3.2-3.7,6.4-3.2 c3.2,0.5,5.6,2.7,5.3,4.9c-0.3,2.3-3.2,3.7-6.4,3.2C606.8,318.9,604.4,316.7,604.7,314.5z"
  }), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 289.2676 898.0942)",
    className: "st1",
    cx: 597.1,
    cy: 303.3,
    rx: 3.8,
    ry: 2.6
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 307.4723 868.8481)",
    className: "st2",
    cx: 591.5,
    cy: 279.5,
    rx: 3.8,
    ry: 2.6
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 309.4155 954.6221)",
    className: "st1",
    cx: 635.6,
    cy: 321.4,
    rx: 3.8,
    ry: 2.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096750018216268107670000017273427086399740547_",
    gradientUnits: "userSpaceOnUse",
    x1: 614.3745,
    y1: 370.567,
    x2: 619.5898,
    y2: 370.567,
    gradientTransform: "matrix(1 0 0 -1 0 701.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096750018216268107670000017273427086399740547_)"
    },
    d: "M614.4,330.7c0-2,1.2-3.8,2.7-3.8 s2.6,1.7,2.6,3.8s-1.2,3.8-2.7,3.8C615.6,334.5,614.4,332.8,614.4,330.7z"
  }), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 290.1457 988.2737)",
    className: "st2",
    cx: 643,
    cy: 348,
    rx: 3.8,
    ry: 2.6
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.144 -0.9896 0.9896 0.144 287.2579 577.7411)",
    className: "st11",
    cx: 477.6,
    cy: 122.8,
    rx: 4.2,
    ry: 6
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.144 -0.9896 0.9896 0.144 323.9586 612.7462)",
    className: "st2",
    cx: 516.2,
    cy: 119.1,
    rx: 4.2,
    ry: 6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142892429016009502600000005404764678288222632_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.0773,
    y1: 609.6368,
    x2: 472.8765,
    y2: 609.6368,
    gradientTransform: "matrix(1 0 0 -1 0 701.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142892429016009502600000005404764678288222632_)"
    },
    d: "M461.1,90.8c0.3-2.3,3.2-3.7,6.4-3.2 c3.2,0.5,5.6,2.7,5.3,4.9c-0.3,2.3-3.2,3.7-6.4,3.2S460.8,93.1,461.1,90.8z"
  }), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 370.393 532.4707)",
    className: "st1",
    cx: 453.5,
    cy: 79.6,
    rx: 3.8,
    ry: 2.6
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 388.5978 503.2245)",
    className: "st2",
    cx: 447.8,
    cy: 55.8,
    rx: 3.8,
    ry: 2.6
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 390.541 588.9985)",
    className: "st1",
    cx: 492,
    cy: 97.7,
    rx: 3.8,
    ry: 2.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178189073657904264180000013094544711012790704_",
    gradientUnits: "userSpaceOnUse",
    x1: 470.7442,
    y1: 594.2534,
    x2: 475.9595,
    y2: 594.2534,
    gradientTransform: "matrix(1 0 0 -1 0 701.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178189073657904264180000013094544711012790704_)"
    },
    d: "M470.7,107c0-2,1.2-3.8,2.7-3.8 c1.4,0,2.6,1.7,2.6,3.8c0,2-1.2,3.8-2.7,3.8C471.9,110.8,470.7,109.1,470.7,107z"
  }), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.561358e-03 -1 1 7.561358e-03 371.271 622.6501)",
    className: "st2",
    cx: 499.3,
    cy: 124.3,
    rx: 3.8,
    ry: 2.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationWelcome);
export default __webpack_public_path__ + "static/media/illustration_welcome.850bc5f3fcb7c6a095aead5c46098df1.svg";
export { ForwardRef as ReactComponent };